import { useEffect, useState } from "react";

/**
 * FEAT-044 — returns true once loading has run continuously for `delayMs`.
 * Used to escalate loading copy to a "system is waking up" message when a
 * cold backend is taking a while. Resets when `active` goes false.
 */
export function useSlowLoad(active: boolean, delayMs = 5000): boolean {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!active) {
      setSlow(false);
      return;
    }
    const t = setTimeout(() => setSlow(true), delayMs);
    return () => clearTimeout(t);
  }, [active, delayMs]);
  return slow;
}
